export enum UpdateTokenAction {
  UPDATE_EXPIRED = '0', // update expired token action
  UPDATE_INTERVAL = '1', // update action in background task launched after EXPIRED_ERROR
  UPDATE_MANUAL = '2' // update action on click refresh button
}
